import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Monthly from "@/pages/Monthly";
import Annual from "@/pages/Annual";
import ImportPage from "@/pages/Import";
import Vendors from "@/pages/Vendors";
import Members from "@/pages/Members";
import Savings from "@/pages/Savings";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import History from "@/pages/History";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="mensuel" element={<Monthly />} />
              <Route path="annuel" element={<Annual />} />
              <Route path="epargne" element={<Savings />} />
              <Route path="projets" element={<Projects />} />
              <Route path="projets/:id" element={<ProjectDetail />} />
              <Route path="import" element={<ImportPage />} />
              <Route path="prestataires" element={<Vendors />} />
              <Route path="membres" element={<Members />} />
              <Route path="historique" element={<History />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
